import './App.css';
import { useNavigate } from "react-router-dom";

function HomeCard({
    icon,
    title,
    link,
}) {
    const navigate = useNavigate();

    return (
        <div style={{ margin: '1em' }}>
            <div
                onClick={() => navigate(link)}
                style={{ cursor: 'pointer' }}
            >
                <div>
                    <i className={icon} style={{ fontSize: '1.5rem' }} />
                    <div style={{ marginLeft: '0.4em' }}>
                        {title}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeCard;